
















import { Vue, Component } from "vue-property-decorator";
import FinalDocumentForm from "@/components/final-document/FinalDocumentForm.vue";
import { FinalDocument as IFinalDocument } from "@/api/models/final-document";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({ components: { CBreadCrumbs, FinalDocumentForm } })
export default class FinalDocumentEdit extends Vue {
  finalDocument!: IFinalDocument;
  data() {
    return {
      finalDocument: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "finalDocumentList" },
        label: `${this.$tc(this.$translate.FinalDocuments)}`
      },
      {
        to: { name: "finalDocument", params: { id: this.finalDocument.id } },
        label: this.finalDocument.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getFinalDocument() {
    api.FinalDocumentApi.get(this.$route.params.id).then(
      (res: { data: IFinalDocument }) => {
        this.finalDocument = res.data;
      }
    );
  }

  mounted() {
    this.getFinalDocument();
  }
}
